/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

  export function meevoUpperCaseLettersOnlyFilter(): angular.IFilterService {
    const filter = (input: any) => {

      if (!input) {
        return "";
      }

      return input.toString().replace(/[^A-Za-z]/g, '').toUpperCase();
    };
    return filter;
  }


  angular.module("meevo.components.filters")
      .filter("meevoUpperCaseLettersOnly", meevoUpperCaseLettersOnlyFilter);
}
